<div class="report-container">
  <mat-card class="report-card">
    <mat-card-header class="report-header">
      <div>
      <mat-card-title>Generador de Reportes de Ventas</mat-card-title>
      <mat-card-subtitle>Visualiza y analiza el desempeño de tus ventas</mat-card-subtitle>
      </div>
    </mat-card-header>

    <mat-card-content class="report-content">
      <div class="period-controls">
        <button mat-icon-button color="primary" (click)="changePeriod('prev')" [disabled]="!reportForm.get('startDate')?.value">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="period-text">
          <h3>{{ periodTitle }}</h3>
          <p [class.clickable-date]="isDayView" (click)="openDayPicker()" *ngIf="isDayView; else normalSubtitle">
            {{ periodSubtitle }}
            <mat-icon class="date-picker-icon">calendar_today</mat-icon>
          </p>
          <ng-template #normalSubtitle>
            <p>{{ periodSubtitle }}</p>
          </ng-template>
        </div>
        <button mat-icon-button color="primary" (click)="changePeriod('next')" [disabled]="!reportForm.get('startDate')?.value">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <!-- Date picker oculto para selección de día -->
      <input matInput [matDatepicker]="dayPicker" style="display: none;" [value]="reportForm.get('startDate')?.value" (dateChange)="onDaySelected($event)">
      <mat-datepicker #dayPicker [startAt]="reportForm.get('startDate')?.value"></mat-datepicker>

      <form [formGroup]="reportForm" class="filters-grid">
          <mat-form-field appearance="outline">
            <mat-label>Vista del reporte</mat-label>
            <mat-select formControlName="viewType">
              <mat-option *ngFor="let option of viewOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="reportForm.get('viewType')?.value === 'custom'">
            <mat-label>Fecha inicial</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="reportForm.get('viewType')?.value === 'custom'">
            <mat-label>Fecha final</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>

        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="loadReports()"
          [disabled]="loading">
            <mat-icon>refresh</mat-icon>
          Generar reporte
          </button>
      </form>

      <ng-container *ngIf="dataLoaded; else loadingTemplate">
        <ng-container *ngIf="hasData; else emptyTemplate">
          <div class="report-body-scroll">
            <section class="summary-grid" *ngIf="salesSummary">
        <mat-card class="summary-card">
            <mat-icon mat-card-avatar>attach_money</mat-icon>
                <div>
                  <h4>Total Ventas</h4>
                  <span>{{ totalVentas | currency }}</span>
                </div>
        </mat-card>

        <mat-card class="summary-card">
                <mat-icon mat-card-avatar>receipt_long</mat-icon>
                <div>
                  <h4>Ventas Realizadas</h4>
                  <span>{{ cantidadVentas }}</span>
                </div>
        </mat-card>

        <mat-card class="summary-card">
            <mat-icon mat-card-avatar>shopping_cart</mat-icon>
                <div>
                  <h4>Productos Vendidos</h4>
                  <span>{{ totalProductosVendidos }}</span>
                </div>
        </mat-card>
            </section>

            <section class="charts-grid" *ngIf="salesByDate.length || topProducts.length">
              <mat-card class="chart-card" *ngIf="salesByDate.length">
                <div class="section-title">
          <h3>Ventas por Fecha</h3>
                </div>
          <div class="chart-container">
                  <canvas
                    baseChart
              [data]="barChartData"
              [options]="barChartOptions"
              [type]="barChartType">
            </canvas>
          </div>
              </mat-card>

              <mat-card class="chart-card" *ngIf="topProducts.length">
                <div class="section-title">
          <h3>Top 10 Productos Más Vendidos</h3>
                </div>
                <div class="chart-container pie">
                  <canvas
                    baseChart
              [data]="pieChartData"
              [options]="pieChartOptions"
              [type]="pieChartType">
            </canvas>
          </div>
              </mat-card>
            </section>

            <section class="tables-grid">
              <mat-card class="table-card">
                <div class="section-title">
          <h3>Detalle de Ventas</h3>
                </div>
                <div class="table-scroll" *ngIf="salesByDate.length; else emptySalesTable">
                  <table mat-table [dataSource]="salesByDate" class="mat-elevation-z8">
            <ng-container matColumnDef="fecha">
              <th mat-header-cell *matHeaderCellDef>Fecha</th>
              <td mat-cell *matCellDef="let element">
                {{ element.fecha | date: 'dd/MM/yyyy' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="ventasTotales">
              <th mat-header-cell *matHeaderCellDef>Ventas Totales</th>
              <td mat-cell *matCellDef="let element">
                {{ element.ventasTotales | currency }}
              </td>
            </ng-container>

            <ng-container matColumnDef="cantidadVentas">
              <th mat-header-cell *matHeaderCellDef>Cantidad de Ventas</th>
              <td mat-cell *matCellDef="let element">
                {{ element.cantidadVentas }}
              </td>
            </ng-container>

            <ng-container matColumnDef="productosVendidos">
              <th mat-header-cell *matHeaderCellDef>Productos Vendidos</th>
              <td mat-cell *matCellDef="let element">
                {{ element.productosVendidos }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsSales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsSales;"></tr>
          </table>
        </div>
                <ng-template #emptySalesTable>
                  <p class="empty-table">No hay ventas registradas en este periodo.</p>
                </ng-template>
              </mat-card>

              <mat-card class="table-card">
                <div class="section-title">
          <h3>Top 10 Productos</h3>
                </div>
                <div class="table-scroll" *ngIf="topProducts.length; else emptyTopProductsTable">
          <table mat-table [dataSource]="topProducts" class="mat-elevation-z8">
            <ng-container matColumnDef="posicion">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let element">
                {{ element.posicion }}
              </td>
            </ng-container>

            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Producto</th>
              <td mat-cell *matCellDef="let element">
                {{ element.nombre }}
              </td>
            </ng-container>

            <ng-container matColumnDef="cantidadVendida">
              <th mat-header-cell *matHeaderCellDef>Cantidad Vendida</th>
              <td mat-cell *matCellDef="let element">
                {{ element.cantidadVendida }}
              </td>
            </ng-container>

            <ng-container matColumnDef="totalVendido">
              <th mat-header-cell *matHeaderCellDef>Total Vendido</th>
              <td mat-cell *matCellDef="let element">
                {{ element.totalVendido | currency }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsTopProducts"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsTopProducts;"></tr>
          </table>
        </div>
                <ng-template #emptyTopProductsTable>
                  <p class="empty-table">No hay productos registrados en este periodo.</p>
                </ng-template>
              </mat-card>
            </section>

            <!-- Sección: Ventas por Método de Pago -->
            <section class="metodo-pago-section" *ngIf="salesByMetodoPago.length">
              <mat-card class="table-card full-width">
                <div class="section-title">
                  <h3>Ventas por Método de Pago</h3>
                </div>
                <div class="metodo-pago-cards">
                  <mat-card class="metodo-card" *ngFor="let mp of salesByMetodoPago"
                    [style.border-left-color]="metodoPagoColors[mp.metodoPago] || '#9E9E9E'">
                    <div class="metodo-icon">
                      <mat-icon [style.color]="metodoPagoColors[mp.metodoPago] || '#9E9E9E'">
                        {{ mp.metodoPago === 'tarjeta' ? 'credit_card' : mp.metodoPago === 'transferencia' ? 'swap_horiz' : 'payments' }}
                      </mat-icon>
                    </div>
                    <div class="metodo-info">
                      <h4>{{ metodoPagoLabels[mp.metodoPago] || mp.metodoPago }}</h4>
                      <span class="metodo-total">{{ mp.total | currency }}</span>
                      <span class="metodo-cantidad">{{ mp.cantidad }} transacciones</span>
                    </div>
                  </mat-card>
                </div>
              </mat-card>
            </section>
      </div>
        </ng-container>
      </ng-container>

      <ng-template #loadingTemplate>
        <div class="loading-state">
          <mat-spinner diameter="48"></mat-spinner>
        <p>Cargando reporte...</p>
      </div>
      </ng-template>

      <ng-template #emptyTemplate>
        <div class="empty-state">
          <mat-icon>insights</mat-icon>
          <h3>No hay datos en el rango seleccionado</h3>
          <p>Ajusta los filtros de fecha o selecciona otra vista para consultar tus ventas.</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>
